import { Component, OnInit, Inject, EventEmitter, Pipe, DebugElement } from '@angular/core';
import { PrefaReglasInfo } from '@core/model/prefaReglasinfo.model';
import { ModelsService } from '@shared/service/models.service';
import { takeUntil, } from 'rxjs/operators';
import { utiles } from '@utl/environment';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { GlassInfo } from '@core/model/glassInfo.model';
import { PrefaSinReglasInfo } from '@core/model/PrefaSinReglasInfo.mode';

@Component({
  selector: 'app-modal-prefa-distribution',
  templateUrl: './modal-prefa-distribution.component.html',
  styleUrls: ['./modal-prefa-distribution.component.scss']
})
export class ModalPrefaDistributionComponent implements OnInit {
  labelTitile: string;
  ErrorLuzMessage: string;
  cont=0;
  activemessage= false;
  public PrefaInfoModel: PrefaReglasInfo;
  public PrefaSinReglasInfoModel: PrefaSinReglasInfo;
  private unsubscribe$ = new Subject<void>();
  public vOrigen: number;
  public vReglas: boolean;

  constructor(
    public dialogRef: MatDialogRef<ModalPrefaDistributionComponent>,
    @Inject(MAT_DIALOG_DATA) public dataMessage: any,
    private ModelsService: ModelsService,) {
      if (this.dataMessage !== null && this.dataMessage !== undefined) {
        if(this.dataMessage.Reglas === true){
          this.labelTitile = this.dataMessage.labelTitile;
          this.PrefaInfoModel = this.dataMessage.PrefaInfoModel;
          this.vOrigen = this.dataMessage.Origin;
          this.vReglas = this.dataMessage.Reglas;
        }else{
          this.labelTitile = this.dataMessage.labelTitile;
          this.PrefaSinReglasInfoModel = this.dataMessage.PrefaSinReglasInfoModel;
          this.vOrigen = this.dataMessage.Origin;
          this.vReglas = this.dataMessage.Reglas;
        }
      }
  }

  ngOnInit(): void {
  }

  ResetMedidas() {
    this.ErrorLuzMessage='';
    this.cont=0;
    if(this.vReglas === true){
      this.PrefaInfoModel.vListaLuzCapa.forEach(luz => {
        luz.vAnchoModificado = false;
      });
    }else{
      this.PrefaSinReglasInfoModel.vListaLuzCapa.forEach(luz => {
        luz.vAnchoModificado = false;
      });
    }  
    this.recalcMedidasModelo();
  }

  cambiaMedidaLuz(numLuz, estiloLuz, e) {
    
    this.ErrorLuzMessage='';
    if(e.currentTarget.value)
    {
      if(this.vReglas === true){
        if(this.PrefaInfoModel.vAncho1 > e.currentTarget.value) {
          this.PrefaInfoModel.vListaLuzCapa.forEach(luz => {
            if (luz.vNumeroLuz === numLuz) {
              luz.vAncho1 = e.currentTarget.value;
              luz.vAnchoModificado = true;
              this.recalcMedidasModelo();
              
            } 
          });
        } else {
          this.ErrorLuzMessage='No es posible agregar una luz mayor al ancho total '+this.PrefaInfoModel.vAncho1;
        }
      }else{
        if(this.PrefaSinReglasInfoModel.vAncho1 > e.currentTarget.value) {
          this.PrefaSinReglasInfoModel.vListaLuzCapa.forEach(luz => {
            if (luz.vNumeroLuz === numLuz) {
              luz.vAncho1 = e.currentTarget.value;
              luz.vAnchoModificado = true;
              this.recalcMedidasModelo();
              
            } 
          });
        } else {
          this.ErrorLuzMessage='No es posible agregar una luz mayor al ancho total '+this.PrefaSinReglasInfoModel.vAncho1;
        }
      }  
    }
    this.activemessage=true;
  }

  CalcularTotal(){
    let Acum: number;
    let Mensaje: string;
    Mensaje='';
    Acum = 0;

    if(this.vReglas === true){
      this.PrefaInfoModel.vListaLuzCapa.forEach(luz => {
        Acum = Acum + Number(luz.vAncho1);
      });

      if(Acum !==this.PrefaInfoModel.vAncho1) {
        Mensaje='El total de las luces es '+Acum+' supera el marco total de '+this.PrefaInfoModel.vAncho1;
      }
    }else{
      this.PrefaSinReglasInfoModel.vListaLuzCapa.forEach(luz => {
        Acum = Acum + Number(luz.vAncho1);
      });

      if(Acum !==this.PrefaSinReglasInfoModel.vAncho1) {
        Mensaje='El total de las luces es '+Acum+' supera el marco total de '+this.PrefaSinReglasInfoModel.vAncho1;
      }

    }
    return Mensaje;
  }

  SelecLuz(numLuz) {
    this.dialogRef.close(numLuz);
  }

  recalcMedidasModelo() {
    this.cont++;

    if(this.vReglas === true){
      this.ModelsService.recalcDimLuces(this.PrefaInfoModel)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
      response => {
        if (response != null) {
          const newModel = JSON.parse(response) as PrefaReglasInfo;
          if(this.PrefaInfoModel.vListaLuzCapa[0].vModelo.vModelo === "VIDRIO CORTADO") {
            let VidrioTmp: GlassInfo = this.PrefaInfoModel.vListaLuzCapa[0].vModelo as GlassInfo;
            let GlassColorList = VidrioTmp.GlassColorList;
            this.PrefaInfoModel.vListaLuzCapa = newModel.vListaLuzCapa;
            VidrioTmp = this.PrefaInfoModel.vListaLuzCapa[0].vModelo as GlassInfo;
            VidrioTmp.GlassColorList = GlassColorList;
          } else {
            this.PrefaInfoModel.vListaLuzCapa = newModel.vListaLuzCapa;
          }
        }
      });
    }else{
      this.ModelsService.recalcDimLucesSinReglas(this.PrefaSinReglasInfoModel)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
      response => {
        if (response != null) {
          const newModel = JSON.parse(response) as PrefaReglasInfo;
          if(this.PrefaSinReglasInfoModel.vListaLuzCapa[0].vModelo.vModelo === "VIDRIO CORTADO") {
            let VidrioTmp: GlassInfo = this.PrefaSinReglasInfoModel.vListaLuzCapa[0].vModelo as GlassInfo;
            let GlassColorList = VidrioTmp.GlassColorList;
            this.PrefaSinReglasInfoModel.vListaLuzCapa = newModel.vListaLuzCapa;
            VidrioTmp = this.PrefaSinReglasInfoModel.vListaLuzCapa[0].vModelo as GlassInfo;
            VidrioTmp.GlassColorList = GlassColorList;
          } else {
            this.PrefaSinReglasInfoModel.vListaLuzCapa = newModel.vListaLuzCapa;
          }
        }
      });
    }
  }

  close() {
    this.dialogRef.close();
  }
}
